import React, { useMemo } from 'react';
import { Button, Progress, Tooltip } from 'antd';
import { Info } from '../../assets/icons';
import './PropertyBuyCard.scss';
import { cardData } from '../../pages/PropertyListing/IOVacationData';
import { useSelector } from 'react-redux';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';
import useScroll from '../../Hooks/useScroll';
import { maxShareCalculatorWithNoOfShare } from '../../utils/maxShareCalculator';
import { remainingDays } from '../../utils/remainingDaysCalculator';

const PropertyBuyCard = ({ onBuyClick, onNotifyClick, isFetchingUserAccount }) => {
  const { data, loading } = useSelector((state) => state.propertyDetails);
  useScroll('.data-list');

  const notifyLoading = useSelector((state) => state.notifyMeSlice.loading);
  const newCardData = {
    ...cardData,
    cardInfoData: cardData.cardInfoData.map((x) => {
      switch (x.label) {
        case 'Shares remaining':
          x.value = getUsCurrencyFormatWithoutDecimal(Number(data?.data?.sharesRemaining) || 0) || '0';
          break;
        case 'Investors':
          x.value = getUsCurrencyFormatWithoutDecimal(Number(data?.data?.noOfInvestors) || 0) || '0';
          break;
        case 'Share price':
          x.value = getUsCurrencyFormat(Number(data?.data?.finance?.perSharePrice || 0)) || '0';
          break;
        default:
          break;
      }
      x.value = x.prefix ? `${x.prefix}${x.value}` : x.value;
      return x;
    }),
  };
  const fundingProgress = useMemo(() => {
    // if (data?.data?.totalShare && data?.data?.sharesPurchased) {
    //   return getUsPercentageFormat((Number(data?.data?.sharesPurchased) * 100) / Number(data?.data?.totalShare), 4);
    // }
    if (data?.data?.percentageFunded) {
      return data?.data?.percentageFunded;
    }
    return 0;
  }, [data?.data?.percentageFunded]);
  return (
    <div className='buy-initial'>
      {data?.data?.tag !== 'Coming Soon' ? (
        <>
          {remainingDays(data?.data?.duration) >= 0 || loading ? (
            <Button
              disabled={
                Number(fundingProgress) >= 100 ||
                maxShareCalculatorWithNoOfShare(Number(data?.data?.totalShare), 0, Number(data?.data?.userPurchaseDetail?.noOfShares)) < 1
              }
              className='w-100 mb-24'
              type='primary'
              onClick={onBuyClick}
              loading={isFetchingUserAccount}
            >
              {newCardData.buyLabel}
            </Button>
          ) : (
            <span className='text-error fz-14'>This property has been expired.</span>
          )}
        </>
      ) : (
        <Button
          className='w-100 mb-24'
          onClick={() => onNotifyClick({ id: data?.data?.propertyId, isSecondary: data?.data?.isSecondary })}
          loading={notifyLoading}
        >
          Notify me
        </Button>
      )}
      <div className='data-list'>
        {newCardData.cardInfoData.map((cardInfo, index) => {
          return (
            <div className='data-list__item' key={index}>
              <Tooltip title={cardInfo.tooltip}>
                <span className={cardInfo.tooltip ? 'data-list__item__label tooltip' : 'data-list__item__label'}>
                  {cardInfo.label} {cardInfo.tooltip && <Info marginLeft='2px' />}
                </span>
              </Tooltip>
              <span className='data-list__item__value'>{cardInfo.value}</span>
            </div>
          );
        })}
      </div>
      {fundingProgress >= 0 ? (
        <div className='progressbar'>
          <Progress percent={fundingProgress} format={(percent) => `${percent}% funded`} />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

PropertyBuyCard.propTypes = {
  // onBuyClick: PropTypes.func,
};

export default PropertyBuyCard;
